



































































































































































































































































// @ts-nocheck
import Vue from "vue";
import moment from "moment";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig, UseModal } from "@/components/root/modal";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { UseEventsCollection } from "./use-events";
import { table_config } from "./table.config";
import { merge_and_fix_cords } from "./cords";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from "@vue/composition-api";
import { EventBus } from "@/eventbus";
import EventTableRow, { EVENT_ROW_TOGGLE_MARK } from "./EventTableRow.vue";
import { emptyFn } from "@/fp";
import * as menus from "./menus";
import Filters from "@/components/filters/Filters.vue";
import { create_filters_config } from "@/components/filters/filters.state";
import { EventsModalProps } from "./model";
import { SharedState } from "@/common/state";
import {
  CoordinateInputTier3,
  EventTypeMap,
  ExternalEventType,
  JustificationStatus,
  MarkedStatus,
  TimeAxisRangeInput,
} from "@/gql/types";
import AppSwitch from "@/components/AppSwitch.vue";
import { pxToRem, remToPx } from "@/common/dom.functions";
import FilesModalVue from "@/components/modals/files-modal/FilesModal.vue";
import EventDetailsGate from "../EventDetailsGate.vue";
import JustificaionDetailsModal from "@/views/customize/in-motion/justification/JustificaionDetailsModal.vue";
import { POPULATION_TYPE } from "@/common/models";
import { UsePopup } from "@/components/root/popup/popup.state";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { markEventHandled, unmarkEventHandled } from "@/common/api/events.api";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import { GqlCache } from "@/gql/lib";

export default Vue.extend({
  components: {
    Modal,
    VirtualTable,
    Filters,
    AppSwitch,
    DropDownSimple,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const filterCmp: Ref<{
      get_tags: () => Record<string, string | number>;
    } | null> = ref(null);
    const display_as_events = ref(true);
    const toast = UseToast();

    const time_frame = computed(() => {
      const { from, type } = SharedState.selectedTimeFrameOption.value;
      return { type, values: [from] } as TimeAxisRangeInput;
    });

    const modal_data = computed(() => props.modalData as EventsModalProps);

    const filter_cords: Ref<CoordinateInputTier3[]> = ref([]);
    const handledFilter = ref<MarkedStatus | null>(null);
    const justificationFilter = ref<JustificationStatus | null>(null);
    const show_justification_automation = computed(() =>
      SharedState.FeatureHelper.is_enabled("justification_automation")
    );
    const show_mark_as_handled = computed(() =>
      SharedState.FeatureHelper.is_enabled("mark_as_handled")
    );
    const handledOptions = [
      { id: "any", name: "Any" },
      { id: MarkedStatus.Marked, name: "Handled" },
      { id: MarkedStatus.NotMarked, name: "Not handled" },
    ];
    const selectedHandledOption = ref(handledOptions[0]);
    const onHandledFilterChange = (option: { id: string; name: string }) => {
      selectedHandledOption.value = option;
      handledFilter.value =
        option.id === "any" ? null : (option.id as MarkedStatus);
    };

    const justificationOptions = [
      { id: "any", name: "All" },
      { id: JustificationStatus.None, name: "No request" },
      { id: JustificationStatus.SentOnly, name: "Awaiting response" },
      {
        id: JustificationStatus.Replied,
        name: "Responded",
      },
    ];
    const selectedJustificationOption = ref(justificationOptions[0]);
    const onJustificationFilterChange = (option: { id: string; name: string }) => {
      selectedJustificationOption.value = option;
      justificationFilter.value =
        option.id === "any" ? null : (option.id as JustificationStatus);
    };

    // eventTypeOptions and selectedEventTypeOption are defined after eventsWithInferredMark (below)
    const selectedEventTypeOption = ref({ id: "any", name: "All event types" });
    const selectedExternalEventTypes = ref<ExternalEventType[] | null>(null);
    const isBackendExternalEventTypeFilterEnabled = true;
    const currentBackendExternalEventTypesFilter = () =>
      isBackendExternalEventTypeFilterEnabled
        ? selectedExternalEventTypes.value
        : null;
    const markingEvents = ref<Record<string, boolean>>({});
    const invalidateEventsCache = () => {
      ["exposure-events", "tier3-events"].forEach((tag) =>
        GqlCache.removeByTag(tag)
      );
    };
    const showMoreFilters = ref(false);
    const toggleMoreFilters = async () => {
      if (showMoreFilters.value) {
        // Collapsing — just hide, keep filter values
        showMoreFilters.value = false;
      } else {
        // Expanding — if any status filter is active, reload to get fresh data
        showMoreFilters.value = true;
        if (handledFilter.value !== null || justificationFilter.value !== null) {
          await reloadEvents();
        }
      }
    };

    const {
      items: events,
      is_loading,
      has_more,
      clear: clear_events,
      load_items: load_events,
      update_item,
      load_more_items: load_more,
      has_no_results,
    } = UseEventsCollection(
      () =>
        merge_and_fix_cords(modal_data.value.coordinates, filter_cords.value),
      {
        clusterUID: modal_data.value.clusterUID,
        statusFilters: () => ({
          mark: handledFilter.value,
          justification: show_justification_automation.value
            ? justificationFilter.value
            : null,
          externalEventTypes: currentBackendExternalEventTypesFilter(),
          ...currentDateRangeFilter(),
        }),
      }
    );

    // Workaround: Backend returns mark:null even for filtered events
    // Infer mark value from current filter when server doesn't provide it
    const eventsWithInferredMark = computed(() => {
      const normalized = events.value.map((event: any) => {
        let markValue = event.mark;
        if (markValue === null || markValue === undefined) {
          if (handledFilter.value === MarkedStatus.Marked) {
            markValue = true;
          } else if (handledFilter.value === MarkedStatus.NotMarked) {
            markValue = false;
          }
        }
        if (markValue === event.mark) {
          return event;
        }
        return {
          ...event,
          mark: markValue,
        };
      });
      return normalized;
    });

    // Only event types covered by the in-motion flow are offered as filter options.
    const supportedEventTypes = [
      ExternalEventType.Email,
      ExternalEventType.FileUploaded,
      ExternalEventType.FileSyncUploadedFull,
      ExternalEventType.FileDownloaded,
      ExternalEventType.SharingSet,
      ExternalEventType.CompanyLinkCreated,
      ExternalEventType.AnonymousLinkCreated,
      ExternalEventType.AnonymousLinkUpdated,
      ExternalEventType.SecureLinkCreated,
    ];
    const eventTypeOptions = (() => {
      const allOption = { id: "any", name: "All event types" };
      const seen = new Set<string>();
      const types = supportedEventTypes
        .map((id) => ({ id, name: EventTypeMap[id] || id }))
        .filter((name) => {
          if (!name.name || seen.has(name.name)) return false;
          seen.add(name.name);
          return true;
        })
        .sort((a, b) => a.name.localeCompare(b.name));
      return [allOption, ...types];
    })();

    const virtualTableRef = ref<any>(null);
    const scrollTableToTop = () => {
      virtualTableRef.value?.scrollToTop?.();
    };

    const onEventTypeFilterChange = async (option: { id: string; name: string }) => {
      selectedEventTypeOption.value = option;
      selectedExternalEventTypes.value =
        option.id === "any" ? null : [option.id as ExternalEventType];
      scrollTableToTop();
      await reloadEvents();
    };

    const filteredEvents = computed(() => {
      let result = eventsWithInferredMark.value;
      // Justification filter (client-side to complement backend filtering)
      if (justificationFilter.value === JustificationStatus.None) {
        result = result.filter((e: any) => !e.justification || !e.justification.id);
      } else if (justificationFilter.value === JustificationStatus.SentOnly) {
        result = result.filter(
          (e: any) => e.justification && e.justification.id && e.justification.status !== "Completed"
        );
      } else if (justificationFilter.value === JustificationStatus.Replied) {
        result = result.filter(
          (e: any) => e.justification && e.justification.id && e.justification.status === "Completed"
        );
      }
      // Event type filter
      if (selectedEventTypeOption.value.id !== "any") {
        result = result.filter(
          (e: any) => e.event_type === selectedEventTypeOption.value.name
        );
      }
      // Date range filter
      if (appliedFromTs.value !== null) {
        result = result.filter((e: any) => moment(e.date).valueOf() >= appliedFromTs.value!);
      }
      if (appliedToTs.value !== null) {
        result = result.filter((e: any) => moment(e.date).valueOf() <= appliedToTs.value!);
      }
      return result;
    });

    // ── Date range filter state ─────────────────────────────────────────
    // Bounds are derived from the actual loaded event dates.
    // Applied filter (null = no filter)
    const appliedFromTs = ref<number | null>(null);
    const appliedToTs = ref<number | null>(null);
    const formatDateFilter = (ts: number) => moment(ts).format("YYYY-MM-DD");
    const currentDateRangeFilter = () => ({
      fromDate:
        appliedFromTs.value !== null
          ? formatDateFilter(appliedFromTs.value)
          : null,
      toDate:
        appliedToTs.value !== null ? formatDateFilter(appliedToTs.value) : null,
    });

    // Pending (in-panel) slider offsets in days from min event date
    const pendingFromOffset = ref(0);
    const pendingToOffset = ref(0);
    const showDatePanel = ref(false);
    const dateRangeRef = ref<HTMLElement | null>(null);

    // Date range slider bounds are always derived from the global time scope,
    // never from which events happen to be loaded in the current page.
    //
    // For Week type, `selectedTimeFrameOption.from` is an anchor day somewhere
    // inside the ISO week (today for current week, today-7d for last week).
    // We normalize the scope to Monday..Sunday of that ISO week (capped at now).
    // For Month type, `from` = first day of the month.
    const scopeStartTs = computed(() => {
      const option = SharedState.selectedTimeFrameOption.value;
      if (option.type === "Week") {
        return moment(option.from).isoWeekday(1).startOf("day").valueOf();
      }
      // Month: `from` is already the 1st of the month
      return moment(option.from).startOf("day").valueOf();
    });

    const scopeEndTs = computed(() => {
      const option = SharedState.selectedTimeFrameOption.value;
      const now = Date.now();
      // Explicit `to` date (e.g. date-range mode on Overview pages)
      if ((option as any).to) {
        return Math.min(moment((option as any).to).endOf("day").valueOf(), now);
      }
      // Week: scope runs Mon..Sun of that ISO week, capped at now.
      // Using `from.endOf("day")` is wrong because `from` may be any day inside
      // the week (e.g. Monday for "last week"), which would collapse the range
      // to a single day.
      if (option.type === "Week") {
        const weekEnd = moment(option.from)
          .isoWeekday(1)
          .add(6, "days")
          .endOf("day")
          .valueOf();
        return Math.min(weekEnd, now);
      }
      // Month: scope runs to end of the `from` month, cap at now
      if (option.type === "Month") {
        return Math.min(moment(option.from).endOf("month").valueOf(), now);
      }
      return now;
    });

    const minEventTs = computed(() => scopeStartTs.value);
    const maxEventTs = computed(() => scopeEndTs.value);

    // Total days span for slider — normalize to day boundaries to match offsetToTs
    const dateRangeTotalDays = computed(() =>
      moment(maxEventTs.value).startOf("day").diff(moment(minEventTs.value).startOf("day"), "days")
    );

    // Convert offset (days from minEventTs) -> timestamp
    const offsetToTs = (offset: number) =>
      moment(minEventTs.value).startOf("day").add(offset, "days").valueOf();

    // Convert timestamp -> offset (reverse of offsetToTs)
    const tsToOffset = (ts: number) =>
      moment(ts).startOf("day").diff(moment(minEventTs.value).startOf("day"), "days");

    // Revert pending slider offsets to match the last applied values
    const revertPendingDateRange = () => {
      if (appliedFromTs.value !== null) {
        pendingFromOffset.value = tsToOffset(appliedFromTs.value);
      } else {
        pendingFromOffset.value = 0;
      }
      if (appliedToTs.value !== null) {
        pendingToOffset.value = tsToOffset(appliedToTs.value);
      } else {
        pendingToOffset.value = dateRangeTotalDays.value;
      }
    };

    // Labels
    const fmtTs = (ts: number) => moment(ts).format("MMM D");
    const dateRangeMinLabel = computed(() => fmtTs(minEventTs.value));
    const dateRangeMaxLabel = computed(() => fmtTs(maxEventTs.value));
    const pendingFromLabel = computed(() => fmtTs(offsetToTs(pendingFromOffset.value)));
    const pendingToLabel = computed(() => fmtTs(offsetToTs(pendingToOffset.value)));

    // Trigger button label
    const dateRangeLabel = computed(() => {
      if (appliedFromTs.value === null && appliedToTs.value === null) return "Any date";
      const from = fmtTs(appliedFromTs.value!);
      const to = fmtTs(appliedToTs.value!);
      return `${from} - ${to}`;
    });

    // Slider input handlers — allow from == to (single-day selection)
    // z-index on the inputs ensures neither thumb ever gets stuck.
    const onFromSliderInput = () => {
      if (pendingFromOffset.value > pendingToOffset.value) {
        pendingFromOffset.value = pendingToOffset.value;
      }
    };
    const onToSliderInput = () => {
      if (pendingToOffset.value < pendingFromOffset.value) {
        pendingToOffset.value = pendingFromOffset.value;
      }
    };

    const applyDateRange = async () => {
      appliedFromTs.value = offsetToTs(pendingFromOffset.value);
      appliedToTs.value = moment(offsetToTs(pendingToOffset.value)).endOf("day").valueOf();
      showDatePanel.value = false;
      scrollTableToTop();
      await reloadEvents();
    };

    const resetDateRange = async () => {
      appliedFromTs.value = null;
      appliedToTs.value = null;
      pendingFromOffset.value = 0;
      pendingToOffset.value = dateRangeTotalDays.value;
      showDatePanel.value = false;
      scrollTableToTop();
      await reloadEvents();
    };

    // Close panel on outside click — revert unsaved draft
    const onDatePanelOutsideClick = (e: MouseEvent) => {
      if (dateRangeRef.value && !dateRangeRef.value.contains(e.target as Node)) {
        revertPendingDateRange();
        showDatePanel.value = false;
      }
    };

    const toggleDatePanel = () => {
      if (showDatePanel.value) {
        // Closing — revert unsaved changes
        revertPendingDateRange();
        showDatePanel.value = false;
      } else {
        showDatePanel.value = true;
      }
    };

    const reloadEvents = async () => {
      invalidateEventsCache();
      clear_events();
      await load_events({
        cursor: "",
        externalEventTypes: currentBackendExternalEventTypesFilter(),
        ...currentDateRangeFilter(),
      });
    };

    const setMarkingState = (eventId: string, state: boolean) => {
      markingEvents.value = {
        ...markingEvents.value,
        [eventId]: state,
      };
    };

    const updateEventMark = (eventId: string, mark: boolean) => {
      const event = events.value.find((item: any) => item.id === eventId);
      if (!event) {
        return null;
      }
      return update_item("id", {
        ...event,
        mark,
      });
    };

    const handleToggleMark = async ({
      event_id,
      mark,
    }: {
      event_id: string;
      mark: boolean;
    }) => {
      const revert = updateEventMark(event_id, mark);
      setMarkingState(event_id, true);
      const res = mark
        ? await markEventHandled(event_id)
        : await unmarkEventHandled(event_id);
      setMarkingState(event_id, false);
      if (!res.success) {
        revert && revert();
        toast.show({
          type: ToastType.ALERT,
          msg: "Unable to update event. Please try again.",
        });
        return;
      }
      toast.show({
        type: ToastType.SUCCESS,
        msg: mark ? "Event marked as handled" : "Event unmarked",
      });
      invalidateEventsCache();
    };

    const filters_config = create_filters_config(
      "events",
      modal_data.value.coordinates[0]
    );
    // Hide Information Context filter
    filters_config.context_labels.include = false;

    if (modal_data.value.hide_filters) {
      modal_data.value.hide_filters.forEach((key) => {
        // @ts-ignore
        filters_config[key].include = false;
      });
    }
    if (SharedState.in_motion_services_flags.value.is_google_org_only) {
      filters_config.sources.only = ["gdrive", "gmail", "gchat"];
    } else if (SharedState.in_motion_services_flags.value.is_ms_org_only) {
      filters_config.sources.only = [
        "onedrive",
        "sharepoint",
        "exchange_365",
        "ms_teams",
      ];
    }

    const table_config_with_flags = computed(() => {
      const columns = table_config.columns.filter((column) => {
        if (column.csvOnly) return false;
        return true;
      });
      return {
        ...table_config,
        columns,
      };
    });

    const table_config_for_csv = computed(() => {
      const columns = table_config.columns.filter((column) => {
        if (column.key === "justification" && !show_justification_automation.value) {
          return false;
        }
        return Boolean(column.jsPath);
      });
      return {
        ...table_config,
        columns,
      };
    });

    const modal_config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      backdropDismiss: true,
      width: "120rem",
      height: Math.min(65, pxToRem(innerHeight) * 0.9) + "rem",
    };

    const export_table_as_csv = async (event: MouseEvent) => {
      // check if the user has the permission to generate a report
      if (SharedState.is_biz_user.value) {
        if (SharedState.restrictions.is_restricted_app("reports")) {
          SharedState.restrictions.show_restrictions_modal("app", "Reports");
          return;
        }
      }
      const { state: csv_state } = await import(
        "@/views/reports/data/csv/state.csv"
      );
      const payload = {
        possible_call_tags: ["exposure-events", "tier3-events"],
        table_config: table_config_for_csv.value,
        title: modal_data.value.title,
        tags: {
          ...filterCmp.value!.get_tags(),
          entity_type: POPULATION_TYPE.EVENT,
        },
      };

      if (SharedState.FeatureHelper.is_enabled("csv_report_scheduler")) {
        const res = await UsePopup.showActionPopup({
          type: "TextAndIconDisplayPopup",
          items: [
            { icon: "CSV", text: "Generate csv report" },
            { icon: "Calendar", text: "Schedule csv report" },
          ],
          width: remToPx(15),
          event,
          position: "bottom-left",
        });
        if (res.type == "canceled") {
          return;
        }
        if (res.action == "Schedule csv report") {
          // @ts-ignore
          csv_state.schedule_gql_csv_report(payload);
        } else {
          // @ts-ignore
          csv_state.create_gql_report(payload);
        }
      } else {
        // @ts-ignore
        csv_state.create_gql_report(payload);
      }
    };

    const load_more_events = async () => {
      if (has_more.value) {
        await load_more();
      }
    };

    const on_filters_changed = async (
      cords_from_filter: CoordinateInputTier3[]
    ) => {
      filter_cords.value = [...cords_from_filter];
      await reloadEvents();
    };

    const open_playbook = () => {
      if (SharedState.is_biz_user.value) {
        SharedState.restrictions.show_restrictions_modal("role", "Playbooks");
        return;
      }
      emit("submit", "playbook");
    };

    const subs = {
      switch: emptyFn(),
      show_justification: emptyFn(),
      show_event_details: emptyFn(),
      show_event_menu: emptyFn(),
      new_justification: emptyFn(),
      status_filters: emptyFn(),
      toggle_mark: emptyFn(),
    };

    subs.status_filters = watch(
      [handledFilter, justificationFilter],
      async () => {
        await reloadEvents();
      }
    );

    // Guard against opening more than one details modal at a time. Without it,
    // rapid clicks stack modals and exhaust the fixed modal-slot pool (App.vue),
    // which surfaces as "Cannot set properties of undefined (setting 'is_active')".
    let detailsModalOpen = false;

    onMounted(async () => {
      subs.show_event_details = EventBus.listen(
        "show_event_details",
        async (payload: { item: any; section: any }) => {
          if (detailsModalOpen) return;
          detailsModalOpen = true;
          try {
            const res = await UseModal().show(EventDetailsGate, payload);
            if (res.type === "success" && res.msg) {
              // @ts-ignore
              const { action, payload } = res.msg;
              if (action === "investigate") {
                SharedState.investigation.investigate(payload);
                emit("cancel");
              }
            }
          } finally {
            detailsModalOpen = false;
          }
        }
      );

      subs.show_justification = EventBus.listen(
        "show_justification",
        async (payload: { event_id: string; justification_id: string }) => {
          await UseModal().show(JustificaionDetailsModal, payload);
        }
      );

      subs.show_event_menu = EventBus.listen(
        "showEventMenu",
        async (p: { item: any; event: MouseEvent }) => {
          const res = await menus.ms_event_menu(p);
          if (res === "close") {
            emit("cancel");
          }
        }
      );

      subs.new_justification = EventBus.listen(
        "new-justification",
        async (payload: { event_id: string; justification_id: string }) => {
          const event = events.value.find((f) => f.id === payload.event_id);
          if (event) {
            update_item("id", {
              ...event,
              justification: {
                id: payload.justification_id,
                status: "Opened",
              },
            });
          }
        }
      );
      subs.toggle_mark = EventBus.listen(
        EVENT_ROW_TOGGLE_MARK,
        handleToggleMark
      );
      await load_events({ cursor: "" });
      // Sync slider to full scope range after initial load
      pendingToOffset.value = dateRangeTotalDays.value;

      // Close date panel on outside click
      document.addEventListener("click", onDatePanelOutsideClick);

      subs.switch = watch(
        display_as_events,
        async () => {
          emit("swap");
          UseModal().show(FilesModalVue, {
            // @ts-ignore
            ...props.modalData,
            hide_backdrop: true,
            transition: "none",
          });
        },
        {
          lazy: true,
        }
      );
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
      document.removeEventListener("click", onDatePanelOutsideClick);
    });

    return {
      filterCmp,
      display_as_events,
      filters_config,
      time_frame,
      open_playbook,
      modal_config,
      table_config,
      table_config_with_flags,
      table_config_for_csv,
      filter_cords,
      EventTableRow,
      is_loading,
      has_no_results,
      events: eventsWithInferredMark,
      load_more_events,
      has_more,
      export_table_as_csv,
      on_filters_changed,
      has_reports_enabled: SharedState.FeatureHelper.is_enabled("reports"),
      handledFilter,
      justificationFilter,
      handledOptions,
      selectedHandledOption,
      onHandledFilterChange,
      justificationOptions,
      selectedJustificationOption,
      onJustificationFilterChange,
      eventTypeOptions,
      selectedEventTypeOption,
      onEventTypeFilterChange,
      filteredEvents,
      markingEvents,
      showMoreFilters,
      toggleMoreFilters,
      show_justification_automation,
      show_mark_as_handled,
      // Date range filter
      virtualTableRef,
      dateRangeRef,
      showDatePanel,
      toggleDatePanel,
      dateRangeLabel,
      dateRangeTotalDays,
      dateRangeMinLabel,
      dateRangeMaxLabel,
      pendingFromOffset,
      pendingToOffset,
      pendingFromLabel,
      pendingToLabel,
      onFromSliderInput,
      onToSliderInput,
      applyDateRange,
      resetDateRange,
    } as any;
  },
});
